import React from "react";
import { StatValueSkeleton } from "../../../components/common";

export type EventStatCard = {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
  color?: string;
  description?: string | React.ReactNode;
};

type EventStatsSectionProps = {
  stats?: EventStatCard[];
  loading?: boolean;
  statLabels?: Array<{
    label: string;
    icon?: React.ReactNode;
    color?: string;
  }>;
};

const getGridClassName = (count: number) => {
  if (count === 2) return "grid-cols-1 sm:grid-cols-2";
  if (count === 3) return "grid-cols-1 sm:grid-cols-2 md:grid-cols-3";
  if (count === 5) return "grid-cols-1 sm:grid-cols-2 lg:grid-cols-5";
  if (count === 6) return "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6";
  return "grid-cols-1 sm:grid-cols-2 md:grid-cols-4";
};

const EventStatsSection: React.FC<EventStatsSectionProps> = ({ stats, loading = false, statLabels }) => {
  const items = loading && statLabels?.length ? statLabels : stats;
  if (!items?.length) return null;

  return (
    <div className={`mb-4 grid gap-4 ${getGridClassName(items.length)}`}>
      {items.map((stat, idx) => (
        <div
          key={`${stat.label}-${idx}`}
          className={`relative rounded-lg border border-gray-200 bg-white p-4 dark:border-[#394150] dark:bg-[#212936] ${stat.color || ""}`}
        >
          <div className="flex items-start justify-between">
            <div className="flex-1">
              {!loading ? (
                <div className="text-2xl font-bold text-foreground">{(stat as EventStatCard).value}</div>
              ) : (
                <div className="text-2xl font-bold">
                  <StatValueSkeleton />
                </div>
              )}
              <div className="mb-1 text-sm text-foreground">{stat.label}</div>
              {!loading && (stat as EventStatCard).description ? (
                <div className="mt-1 text-xs text-foreground">{(stat as EventStatCard).description}</div>
              ) : null}
            </div>

            {stat.icon ? (
              <div className="ml-4 flex h-8 w-8 items-center justify-center rounded-lg bg-[#F2FCFA] dark:bg-emerald-900/30">
                <div className="text-emerald-600 dark:text-emerald-400">{stat.icon}</div>
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
};

export default EventStatsSection;
